import api from '../../apiClient';

// Target Management APIs
export const targetApi = {
  // Get all targets
  getTargets: async (params = {}) => {
    try {
      const response = await api.get('/targets', { params });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get target by ID
  getTargetById: async (id) => {
    try {
      const response = await api.get(`/targets/${id}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Create new target
  createTarget: async (targetData) => {
    try {
      const response = await api.post('/targets', targetData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Update target
  updateTarget: async (id, targetData) => {
    try {
      const response = await api.put(`/targets/${id}`, targetData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Delete target
  deleteTarget: async (id) => {
    try {
      const response = await api.delete(`/targets/${id}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get dashboard data
  getDashboard: async (params = {}) => {
    try {
      // api.get already returns response.data from interceptor
      // Backend returns: { responseCode: 200, responseMessage: "...", data: { kpis: {...}, teamSummary: [...] } }
      const response = await api.get('/crm/targets/dashboard', { params });
      // Return the full response object (which is already response.data from interceptor)
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Export targets
  exportTargets: async (format = 'csv') => {
    try {
      const response = await api.get('/targets/export', { params: { format } });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Bulk delete targets
  bulkDeleteTargets: async (targetIds) => {
    try {
      const response = await api.post('/targets/bulk-delete', { targetIds });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  }
};

// Team Performance APIs
export const teamPerformanceApi = {
  // Get team performance matrix
  getTeamPerformance: async (params = {}) => {
    try {
      // api.get already returns response.data from apiClient interceptor
      const response = await api.get('/crm/targets/team-performance', { params });
      // Response is already the data object from apiClient interceptor
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get individual team member performance details
  getTeamMemberPerformance: async (userId, params = {}) => {
    try {
      const response = await api.get(`/crm/targets/team-performance/${userId}`, { params });
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get individual performance (legacy - kept for backward compatibility)
  getIndividualPerformance: async (id) => {
    try {
      const response = await api.get(`/team-performance/${id}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Update performance
  updatePerformance: async (id, performanceData) => {
    try {
      const response = await api.put(`/team-performance/${id}`, performanceData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get team summary
  getTeamSummary: async () => {
    try {
      const response = await api.get('/team-performance/summary');
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Get regional performance
  getRegionalPerformance: async () => {
    try {
      const response = await api.get('/team-performance/regional');
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Export performance data
  exportPerformance: async (format = 'csv') => {
    try {
      const response = await api.get('/team-performance/export', { params: { format } });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  }
};

// Schedule Management APIs
export const scheduleApi = {
  // Get all schedules
  getSchedules: async (params = {}) => {
    try {
      // apiClient interceptor already returns response.data, so response IS the data
      const response = await api.get('/schedules', { params });
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get schedule by ID
  getScheduleById: async (id) => {
    try {
      // apiClient interceptor already returns response.data, so response IS the data
      const response = await api.get(`/schedules/${id}`);
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Create new schedule
  createSchedule: async (scheduleData) => {
    try {
      // apiClient interceptor already returns response.data, so response IS the data
      const response = await api.post('/schedules', scheduleData);
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Update schedule
  updateSchedule: async (id, scheduleData) => {
    try {
      // apiClient interceptor already returns response.data, so response IS the data
      const response = await api.put(`/schedules/${id}`, scheduleData);
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Delete schedule
  deleteSchedule: async (id) => {
    try {
      // apiClient interceptor already returns response.data, so response IS the data
      const response = await api.delete(`/schedules/${id}`);
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Toggle schedule status
  toggleSchedule: async (id) => {
    try {
      // apiClient interceptor already returns response.data, so response IS the data
      const response = await api.post(`/schedules/${id}/toggle`);
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Run schedule manually
  runSchedule: async (id) => {
    try {
      // apiClient interceptor already returns response.data, so response IS the data
      const response = await api.post(`/schedules/${id}/run`);
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Bulk delete schedules
  bulkDeleteSchedules: async (scheduleIds) => {
    try {
      const response = await api.post('/schedules/bulk-delete', { scheduleIds });
      return response;
    } catch (error) {
      
      throw error;
    }
  }
};

// Combined API object
export const targetAchievementApi = {
  targets: targetApi,
  teamPerformance: teamPerformanceApi,
  schedules: scheduleApi
};

export default targetAchievementApi;

